import z from "zod";
import { OrganizationIdSchema, WorkspaceIdSchema } from "./idTypes";

export const WorkspaceSchema = z.object({
  id: WorkspaceIdSchema,
  tenantId: OrganizationIdSchema,
  organizationId: OrganizationIdSchema,
  name: z.string(),
  displayName: z.string(),
  description: z.string(),
  createdAt: z.string(),
  modifiedAt: z.string(),
});
export type Workspace = z.infer<typeof WorkspaceSchema>;
